import {UserData} from '../Pages/Login/interfaces/login';

export class User {
  constructor(
    public userName?: string,
    public password?: string,
    public userData?: UserData) {}
}

